// PROTOTYPE — a custom edge with a small "×" button at its midpoint to remove it.
// The button appears on hover; clicking it deletes the edge via the setEdges
// callback passed through edge.data.

import {BaseEdge, EdgeLabelRenderer, getBezierPath} from "@xyflow/react";
import {useState} from "react";
import {Box} from "@mui/material";
import {Close as CloseIcon} from "@mui/icons-material";

const BRAND = "#01BBA7";

export default function RemovableEdge({
    id, sourceX, sourceY, targetX, targetY,
    sourcePosition, targetPosition, style, markerEnd, data,
}) {
    const [hovered, setHovered] = useState(false);
    const [edgePath, labelX, labelY] = getBezierPath({
        sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition,
    });

    return (
        <>
            {/* Invisible wide hit-area so hovering near the line reveals the button */}
            <path
                d={edgePath}
                fill="none"
                stroke="transparent"
                strokeWidth={20}
                style={{cursor: "pointer"}}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
            />
            <BaseEdge id={id} path={edgePath} markerEnd={markerEnd}
                      style={{...style, strokeWidth: hovered ? 2 : 1.5}}/>
            <EdgeLabelRenderer>
                <Box
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                    onClick={(e) => {
                        e.stopPropagation();
                        data?.onRemove?.(id);
                    }}
                    sx={{
                        position: "absolute",
                        transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
                        pointerEvents: "all",
                        width: 20, height: 20, borderRadius: "50%",
                        bgcolor: "#fff", border: `1.5px solid ${BRAND}`,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        cursor: "pointer",
                        opacity: hovered ? 1 : 0,
                        transition: "opacity 0.12s",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                        "&:hover": {bgcolor: BRAND, "& svg": {color: "#fff"}},
                    }}
                    title="הסר חיבור"
                >
                    <CloseIcon sx={{fontSize: 13, color: BRAND}}/>
                </Box>
            </EdgeLabelRenderer>
        </>
    );
}
